module.exports = __webpack_public_path__ + "img/icon_partner_1.a571e782.png";